<template>
  <div>
      <p>{{computeCaption(fields_en['select_date'], this.$store.state.lang.value.toLowerCase())}}* </p>
      <br>
    <FunctionalCalendar
    v-model="calendarData"
    :configs="calendarConfigs"
    v-if="!loading"
    ref="dateCalendar"
    ></FunctionalCalendar>
  </div>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
export default {
  name: 'DateSection',
  props: {
    daysBehind: Number,
    daysAhead: Number,
    monthLimit: Number,
    blockedDates: Array,
    disabledDayNames: Array
  },
  components: {
    FunctionalCalendar
  },
  mixins: [
    TranslationsUtils,
    AccessionUtils
  ],
  data () {
    return {
      calendarData: {},
      disabledDates: [],
      loading: false,
      calendarConfigs: {
        sundayStart: false,
        dateFormat: 'yyyy-mm-dd',
        isDatePicker: true,
        isDateRange: false,
        disabledDates: [],
        disabledDayNames: [],
        limits: {min: '2022-8-6', max: '2022-9-6'}
      },
      value: '',
      chosenDate: '',
      fields_en: {
        select_date: 'Please Select a Date'
      }
    }
  },
  methods: {
    getInterval () {
      const date = new Date()
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
      let currentDate = [year, month, day].join('-')
      date.setMonth(date.getMonth() + 1)
      day = date.getDate()
      month = date.getMonth() + this.monthLimit
      year = date.getFullYear()
      let futureDate = [year, month, day].join('-')
      return {min: currentDate, max: futureDate}
    }
  },
  watch: {
    'calendarData.selectedDate': {
      handler (value) {
        if (value) {
          let splitDate = value.split(/[- :]/)
          let d = new Date(splitDate[0], splitDate[1] - 1, splitDate[2])
          let dt = new Date(d)
          const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
          this.chosenDate = weekday[dt.getDay()] + ', ' + month[splitDate[1] - 1] + ' ' + splitDate[2]
          this.value = splitDate[1] + '/' + splitDate[2] + '/' + splitDate[0]
          this.$emit('chosenDate', this.chosenDate, this.value)
        }
      },
      deep: true
    }
  },
  async beforeMount () {
    this.calendarConfigs.limits = this.getInterval()
    this.calendarConfigs.disabledDates = this.blockedDates
    this.calendarConfigs.disabledDayNames = this.disabledDayNames
  },
  computed: {
  }
}
</script>

<style lang="scss">
@import '../../../../../../assets/sass/paper/variables';
.vfc-main-container{
  font-family: 'Muli', "Helvetica", Arial, sans-serif;
  box-shadow: 0px 1px 3px #E7E8E9 !important;
}
.vfc-top-date{
  font-family: 'Muli', "Helvetica", Arial, sans-serif;
}
.vfc-day{
  font-family: 'Muli', "Helvetica", Arial, sans-serif;
}
.vfc-week .vfc-day span.vfc-span-day.vfc-today{
  position: relative;
  background-color: transparent!important;
  color:black!important;
  &::after{
    content: "";
    position: absolute;
    top:5px;
    margin-left:22px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: $primary-color;
  }
}
.vfc-week .vfc-day span.vfc-span-day.vfc-marked{
  background-color: $primary-color!important;
}
.vfc-week .vfc-day span.vfc-span-day.vfc-disabled{
  background-color: #3D3C3C33;
  border-radius: 0!important;
}
.vfc-dayNames {
  border-bottom: 1px solid #e1e1e1;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/ScheduleParts/DatePicker.vue